import { action } from 'typesafe-actions';
import { dashSlaTypes } from './types';

export const dashSlaRequest = (
  dataInicial: string,
  dataFinal: string,
  cd: number,
  inscricao: number[]
) =>
  action(dashSlaTypes.LOAD_RESUMO_ATENDIMENTO_REQUEST, {
    dataInicial,
    dataFinal,
    cd,
    inscricao,
  });

export const dashSlaSucccess = (data: any) =>
  action(dashSlaTypes.RESUMO_ATENDIMENTO_SUCCESS, { data });

export const dashSlaFailure = () => action(dashSlaTypes.RESUMO_ATENDIMENTO_FAILURE);
